export const EVENT_DATE_FORMAT = 'MMM D-YYYY, hh:mm A';
export const EVENT_TYPE = {
  PLAN: 'plan',
  REVIEW: 'review',
};

export const eventStartInPage = {
  todoList: 'To-do_list',
  siteSummary: 'Site_Summary',
  tempConsump: 'Temperature_and_consumption_view',
  liveConnect: 'Live_Connect',
};

export const mapNavItemToStartInPage = {
  siteSummary: 'siteSummary',
  siteDetailsActionableList: 'todoList',
  liveConnetDataView: 'liveConnect',
};

export const eventTypes = {
  draftEvent: 'draft event',
  newEvent: 'new event',
  saveEvent: 'save event',
};

export const eventPageType = {
  siteSummary: 'site_summary',
  todoList: 'todo_list',
  liveConnect: 'live_connect',
  portfolioSiteList: 'portfolio_site_list',
  portfolioSiteTrends: 'portfolio_trends',
};

export const ACTIVE_EVENT_COLOR = '#0096FF';

export const EVENT_TAB_INDEX = {
  pastEvent: 0,
  upcomingEvent: 1,
};

export const CALENDAR_TYPE = {
  OUTLOOK: 'outlook',
  ICALENDAR: 'iCalendar',
  GOOGLE: 'google',
};

export const SUPPORTED_CALENDAR_TYPE = {
  OUTLOOK: 'outlook',
  GOOGLE: 'google',
};

export const EVENT_PAGE_PORTFOLIO_SITE_LIST = 'portfolio_site_list';
export const EVENT_PAGE_PORTFOLIO_TRENDS = 'portfolio_trends';

export const EVENT_VISIBILITY = {
  PUBLIC: 'managing-entity',
  ORG: 'org',
  DEFAULT: 'user',
};

export const MIN_EVENT_DURATION = 60 * 60 * 1000;

/** Applied to portaled react-multi-date-picker calendar root (see react-multi-date.scss). */
export const CREATE_EVENT_DATE_PICKER_POPUP_CLASS = 'rmdp-create-event-popup';

/**
 * Shared react-multi-date-picker props when the field sits inside an MUI Dialog:
 * portal avoids overflow clipping; z-index above default Modal (1300); className adds a visible frame.
 */
export const CREATE_EVENT_MODAL_DATE_PICKER_PROPS = {
  portal: true,
  zIndex: 1700,
  className: CREATE_EVENT_DATE_PICKER_POPUP_CLASS,
};
